import { ROIEventType } from "./types";

export const TERMS_VERSION = "2026-03-17";

export const DEFAULT_ROI_TIMES: Record<ROIEventType, number> = {
  [ROIEventType.GENERATION]: 15,
  [ROIEventType.GENERATE_RX]: 6,
  [ROIEventType.GENERATE_TC]: 18,
  [ROIEventType.GENERATE_RM]: 30,
  [ROIEventType.PHD_AUDIT]: 12,
  [ROIEventType.AUDIT]: 10,
  [ROIEventType.TRANSLATION]: 8,
  [ROIEventType.CONCLUSION]: 5,
  [ROIEventType.REFINE]: 4,
  [ROIEventType.SUMMARIZE]: 3,
  [ROIEventType.SAVE_REPORT]: 2,
  [ROIEventType.IMPROVEMENT]: 5,
  [ROIEventType.STRUCTURE]: 6,
  [ROIEventType.NARRATIVE]: 8,
  [ROIEventType.OPTIMIZE]: 4,
  [ROIEventType.TRANSCRIPTION]: 5,
  [ROIEventType.AGENT_REPORT]: 15,
  [ROIEventType.PHD_ASSISTANCE]: 10,
};

export const ROI_LABELS: Record<ROIEventType, string> = {
  [ROIEventType.GENERATION]: "Generación",
  [ROIEventType.GENERATE_RX]: "Generar RX",
  [ROIEventType.GENERATE_TC]: "Generar TC",
  [ROIEventType.GENERATE_RM]: "Generar RM",
  [ROIEventType.PHD_AUDIT]: "Auditoría PhD",
  [ROIEventType.AUDIT]: "Auditoría",
  [ROIEventType.TRANSLATION]: "Traducción",
  [ROIEventType.CONCLUSION]: "Conclusión",
  [ROIEventType.REFINE]: "Refinar",
  [ROIEventType.SUMMARIZE]: "Resumir",
  [ROIEventType.SAVE_REPORT]: "Guardar Informe",
  [ROIEventType.IMPROVEMENT]: "Mejora",
  [ROIEventType.STRUCTURE]: "Estructurado",
  [ROIEventType.NARRATIVE]: "Narrativa",
  [ROIEventType.OPTIMIZE]: "Optimizar",
  [ROIEventType.AGENT_REPORT]: "Informe Agente",
  [ROIEventType.TRANSCRIPTION]: "Transcripción",
  [ROIEventType.PHD_ASSISTANCE]: "Asistencia PHD",
};

export const PRICING_MAP: Record<string, { input: number; output: number; label: string; color: string }> = {
  'gemini-3.5-flash-lite': { input: 0.30 / 1000000, output: 2.50 / 1000000, label: 'Gemini 3.5 Flash-Lite', color: 'bg-cyan-500' },
  'gemini-3.1-flash-lite': { input: 0.50 / 1000000, output: 1.50 / 1000000, label: 'Gemini 3.1 Flash-Lite', color: 'bg-cyan-600' },
  'gemini-3.8-flash': { input: 0.75 / 1000000, output: 3.75 / 1000000, label: 'Gemini 3.8 Flash', color: 'bg-emerald-600' },
  'gemini-3.5-flash': { input: 1.50 / 1000000, output: 9.00 / 1000000, label: 'Gemini 3.5 Flash', color: 'bg-emerald-500' },
  'gemini-3.1-flash': { input: 0.10 / 1000000, output: 0.40 / 1000000, label: 'Gemini 3.1 Flash', color: 'bg-blue-600' },
  'gemini-2.5-pro': { input: 1.25 / 1000000, output: 5.00 / 1000000, label: 'Gemini 2.5 Pro', color: 'bg-indigo-700' },
  'gemini-1.5-pro': { input: 1.25 / 1000000, output: 5.00 / 1000000, label: 'Gemini Pro', color: 'bg-indigo-600' },
  'gemini-1.5-flash': { input: 0.10 / 1000000, output: 0.40 / 1000000, label: '1.5 Flash Audio', color: 'bg-amber-500' },
  'default-flash': { input: 0.30 / 1000000, output: 2.50 / 1000000, label: 'Flash Series', color: 'bg-blue-400' },
  'default-pro': { input: 3.50 / 1000000, output: 10.50 / 1000000, label: 'Pro Series', color: 'bg-indigo-400' }
};
